import { getCode } from 'country-list';
import { Pipe, PipeTransform } from '@angular/core';
import {
    Currency,
    CurrencyCountryCodes
} from '../components/currency-selector/currency-country-codes';
import { code } from 'currency-codes';

@Pipe({
    name: 'countryCode',
    standalone: true
})
export class CountryCodePipe implements PipeTransform {
    transform(country: string, ccy?: Currency): string | null {
        let countryCode = country ? getCode(country) : null;
        // if country code is not found using country, try to find it by locally defined currency codes
        if (!countryCode && ccy && CurrencyCountryCodes.get(ccy)?.countryCode) {
            countryCode = CurrencyCountryCodes.get(ccy).countryCode;
        } else if (!countryCode && ccy) {
            // if country code is not found using locally defined currency codes, try to find it with currency-codes package
            const countriesByCurrency = code(ccy).countries;
            if (countriesByCurrency.length === 1) {
                countryCode = getCode(countriesByCurrency[0]);
            }
        }
        return countryCode?.toLowerCase() || null;
    }
}
